import { s3ProgressConfig } from "../utils/uploadProgress";
import { withLinkCache } from "../utils/mediaLinkCache";
import { api } from "./axiosClient";
import type { Staff, StaffSearchResponse } from "../types/staff.types";
import axios from "axios";

export const staffApi = {
  searchStaff: async (payload: any) => {
    const response = await api.post<StaffSearchResponse>(
      "/member/Search",
      payload,
    );
    return response.data;
  },

  initUpload: async (ids: string[], groupId?: string) => {
    const response = await api.post("/member/initupload", { ids, groupId });
    return response.data;
  },

  uploadToS3: async (s3Url: string, file: File) => {
    return await axios.put(s3Url, file, {
      ...s3ProgressConfig(file),
      headers: { "Content-Type": file.type },
    });
  },

  uploadMedia: async (_memberId: string, medias: any[]) => {
    const body = {
      medias: medias,
    };
    return await api.post("/member/uploadmedia", body);
  },

  getMediaLink: async (
    ids: string[],
    size: number = 1,
    groupId?: string,
  ): Promise<{ links: Array<{ id: string; link: string }> }> => {
    // Links are reused until they near expiry, so the browser can serve the
    // image from its cache instead of downloading it again (mediaLinkCache).
    return withLinkCache(
      ids,
      `member:${size}:${groupId ?? ""}`,
      async (missing) => {
        const response = await api.post("/member/getmedialink", {
          ids: missing,
          size,
          groupId,
        });
        return response.data;
      },
    );
  },

  createStaff: async (data: Partial<Staff>) => {
    const response = await api.post("/member/create", data);
    return response.data;
  },

  updateStaff: async (data: Partial<Staff>) => {
    const response = await api.post("/member/edit", data);
    return response.data;
  },

  activateStaff: async (id: string) => {
    return await api.post("/member/activate", { id });
  },

  deActivateStaff: async (id: string) => {
    return await api.post("/member/deactivate", { id });
  },

  removeStaff: async (id: string) => {
    return await api.post("/member/remove", { id });
  },

  /** Undoes a removal (Super Admin only); the member comes back active or inactive, as they were. */
  restoreStaff: async (id: string) => {
    return await api.post("/member/remove", { id, undo: true });
  },

  resendEmailConfirmation: async (id: string) => {
    return await api.post("/member/resendemailconfirmation", { id });
  },
};
